var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAprilLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 28,
    viewBox: "0 0 143 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9764 11.046C97.9764 5.45252 93.4238 0.899902 87.8303 0.899902H71.8916V27.6092H76.4895V5.49777H87.8212C90.8805 5.49777 93.3695 7.98678 93.3695 11.046C93.3695 14.1052 90.8805 16.5942 87.8212 16.5942H80.8249C80.8249 21.7623 86.6627 22.7307 91.4235 27.6001H96.8812C95.9128 25.3917 92.8716 22.8212 89.9301 20.9749C94.528 19.9974 97.9764 15.9244 97.9764 11.046Z",
    fill: "#43E3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3142 0.917969C12.1645 4.71031 4.27209 15.0284 0.0996094 27.6092H4.97806C8.345 18.3048 13.857 10.3038 17.2059 5.95028C20.5457 10.2947 26.0577 18.2867 29.4337 27.6092H34.3031C30.1306 15.0284 22.2382 4.71031 19.0885 0.917969H15.3142V0.917969Z",
    fill: "#43E3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4914 0.899902H39.5527V27.6092H44.1506V21.2011H55.4824C61.0758 21.2011 65.6285 16.6485 65.6285 11.055C65.6285 5.46157 61.0849 0.899902 55.4914 0.899902ZM55.4914 16.5942H44.1506V5.49777H55.4824C58.5416 5.49777 61.0306 7.98678 61.0306 11.046C61.0306 14.1052 58.5506 16.5942 55.4914 16.5942Z",
    fill: "#43E3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.272 0.917969H106.557V27.6092H111.272V0.917969Z",
    fill: "#43E3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.342 22.8122V0.899902H121.554V22.8122V27.6001H126.342H142.099V22.8122H126.342Z",
    fill: "#43E3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprilLogo);
export default __webpack_public_path__ + "static/media/april-logo.5bdb15ea.svg";
export { ForwardRef as ReactComponent };